module.exports = __webpack_public_path__ + "img/stamp_good_off.2f5ecac9.svg";